import { render, staticRenderFns } from "./content-blocks.vue?vue&type=template&id=bef6d764"
import script from "./content-blocks.vue?vue&type=script&lang=js"
export * from "./content-blocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports